// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_boxWrapper__oJDTY {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1 1;
}

.styles_selectedBoxRow__L1L-8 {
    display: flex;
    /*justify-content: center;*/
    grid-gap: 26px;
    --item-offset: 110px;
    --item-size: 100px;
    width: 40%;
    margin: 0 auto;
    position: relative;
    min-height: var(--item-size);

    --offset-y: 20px;
    --offset-x: 20px;

    /*padding-left: calc(var(--length, 0) * var(--offset-x, 0));*/
}

.styles_selectedBoxRow__L1L-8:not(:last-of-type) {
    flex: 1 1;
    max-height: 40%;
}

.styles_selectedBoxRowTypeWrapper__xN6XX {
    flex: 1 1;
    position: relative;

    --arrow-size: 8px;
    --icon-color-custom: var(--light-grey);
}

.styles_selectedBoxRowType__LCb7G {
    min-width: var(--item-size);
    width: var(--item-size);
    height: var(--item-size);
    border: 1px dashed var(--light-grey);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    transition: border 0.4s;
    background: #fff;
    padding: 18px;
    --icon-stroke: 1;
}

.styles_selectedBoxRowType__LCb7G > span,
.styles_selectedBoxRowType__LCb7G svg {
    width: 50px;
    height: 50px;
}

.styles_selectedBoxRowType__LCb7G.styles_selected__VqYh0 {
    border: 1px solid var(--primary-color-active);
}

.styles_selectedBoxRowType__LCb7G.styles_selectedIcon__l-msI {
    --icon-color-custom: var(--primary-color-active);
}

.styles_selectedBoxRowTypeWrapper__xN6XX:before,
.styles_selectedBoxRowTypeWrapper__xN6XX:after {
    content: '';
    display: block;
    position: absolute;
    top: calc(var(--item-size) + 10px);
    left: 0;
    right: 0;
    margin: auto;
}

.styles_selectedBoxRowTypeWrapper__xN6XX:after {
    /*top: calc(100% + var(--item-offset) - var(--arrow-size));*/
    top: calc(100% - 18px);
    width: 0;
    height: 0;
    border-left: var(--arrow-size) solid transparent;
    border-right: var(--arrow-size) solid transparent;

    border-top: var(--arrow-size) solid var(--arrow-point-color, var(--light-grey));
}

.styles_selectedBoxRowTypeWrapper__xN6XX:before {
    /*height: calc(var(--item-offset) - var(--arrow-size) * 2);*/
    height: calc(100% - var(--item-size) - 20px);
    width: 1px;
    background: var(--arrow-color, var(--light-grey));
}

.styles_selectedBoxRow__L1L-8:last-of-type .styles_selectedBoxRowTypeWrapper__xN6XX:before,
.styles_selectedBoxRow__L1L-8:last-of-type .styles_selectedBoxRowTypeWrapper__xN6XX:after {
    display: none;
}

/*.selectedBoxRow:not(:last-of-type) {*/
/*    padding-bottom: var(--item-offset);*/
/*}*/

.styles_selectedBoxRow__L1L-8 .styles_investorSelect__mF5qD {
    min-height: 115px;
    margin: auto 0;
    padding: 28px 15px;
}

.styles_selectedBoxRow__L1L-8 .styles_investorSelectTitle__SRHpd {
    height: auto;
}

.styles_selectedBoxRow__L1L-8.styles_full__HKT9g {
    --arrow-color: var(--primary-color-active);
}

.styles_selectedBoxRow__L1L-8.styles_partial__SYG98 {
    --arrow-point-color: var(--primary-color-active);
}

.styles_info__MpFdP {
    width: 180px;
}

.styles_info__MpFdP p {
    font-weight: 300;
    font-size: 12px;
    margin: 10px 0;
    width: 170%;
}

.styles_separator__BL7Y6 {
    margin: 26px 0 40px;
    border: 0;
    border-top: 1px solid var(--light-grey);
}

.styles_countryImg__tOXoF {
    height: 18px;
}

.styles_countryImg__tOXoF img {
    max-height: 100%;
    width: auto;
}

.styles_selectedBoxRowType__LCb7G .styles_countryImg__tOXoF {
    position: absolute;
    top: 7px;
    right: 7px;
}

.styles_selectedBoxRowTypeWrapper__xN6XX.styles_multi__62BjY {
    --index: 1;

    position: absolute;
    height: 100%;

    margin-left: calc(var(--offset-x) * var(--index));
    margin-top: calc(var(--offset-y) * var(--index));
}

.styles_selectedBoxRowType__LCb7G:last-child {
    position: relative;
}

.styles_selectedBoxRowTypeWrapper__xN6XX.styles_multi__62BjY:not(:last-child):before,
.styles_selectedBoxRowTypeWrapper__xN6XX.styles_multi__62BjY:not(:last-child):after {
    display: none;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_selectedBoxRow__L1L-8 {
        grid-gap: 10px;
        --item-size: 80px;

        --offset-y: 15px;
        --offset-x: 15px;
    }

    .styles_selectedBoxRowType__LCb7G {
        /*transform: translateX(40px);*/
        padding: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .styles_selectedBoxRowType__LCb7G > span,
    .styles_selectedBoxRowType__LCb7G svg {
        width: 40px;
        height: 40px;
    }

    .styles_info__MpFdP {
        /*transform: translateX(40px);*/
    }

    .styles_info__MpFdP p {
        width: 170%;
    }

    .styles_info__MpFdP p:first-of-type {
        display: none;
    }

    .styles_countryImg__tOXoF {
        height: 16px;
    }

    .styles_selectedBoxRowType__LCb7G .styles_countryImg__tOXoF {
        top: 5px;
        right: 5px;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .styles_selectedBoxRow__L1L-8 {
        --item-size: 100px;
        justify-content: flex-start;
    }

    .styles_info__MpFdP p {
        font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectionPopup/SelectionResult/styles.module.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAO;AACX;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,4BAA4B;;IAE5B,gBAAgB;IAChB,gBAAgB;;IAEhB,6DAA6D;AACjE;;AAEA;IACI,SAAO;IACP,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,kBAAkB;;IAElB,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,kCAAkC;IAClC,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,4DAA4D;IAC5D,sBAAsB;IACtB,QAAQ;IACR,SAAS;IACT,gDAAgD;IAChD,iDAAiD;;IAEjD,+EAA+E;AACnF;;AAEA;IACI,4DAA4D;IAC5D,4CAA4C;IAC5C,UAAU;IACV,iDAAiD;AACrD;;AAEA;;IAEI,aAAa;AACjB;;AAEA,uCAAuC;AACvC,0CAA0C;AAC1C,IAAI;;AAEJ;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,uCAAuC;AAC3C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,UAAU;;IAEV,kBAAkB;IAClB,YAAY;;IAEZ,iDAAiD;IACjD,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;;QAEjB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,+BAA+B;QAC/B,aAAa;QACb,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@value screen-lg-min, screen-md-max from '../../../breakpoints.css';\n\n.boxWrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    flex: 1;\n}\n\n.selectedBoxRow {\n    display: flex;\n    /*justify-content: center;*/\n    grid-gap: 26px;\n    --item-offset: 110px;\n    --item-size: 100px;\n    width: 40%;\n    margin: 0 auto;\n    position: relative;\n    min-height: var(--item-size);\n\n    --offset-y: 20px;\n    --offset-x: 20px;\n\n    /*padding-left: calc(var(--length, 0) * var(--offset-x, 0));*/\n}\n\n.selectedBoxRow:not(:last-of-type) {\n    flex: 1;\n    max-height: 40%;\n}\n\n.selectedBoxRowTypeWrapper {\n    flex: 1;\n    position: relative;\n\n    --arrow-size: 8px;\n    --icon-color-custom: var(--light-grey);\n}\n\n.selectedBoxRowType {\n    min-width: var(--item-size);\n    width: var(--item-size);\n    height: var(--item-size);\n    border: 1px dashed var(--light-grey);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    transition: border 0.4s;\n    background: #fff;\n    padding: 18px;\n    --icon-stroke: 1;\n}\n\n.selectedBoxRowType > span,\n.selectedBoxRowType svg {\n    width: 50px;\n    height: 50px;\n}\n\n.selectedBoxRowType.selected {\n    border: 1px solid var(--primary-color-active);\n}\n\n.selectedBoxRowType.selectedIcon {\n    --icon-color-custom: var(--primary-color-active);\n}\n\n.selectedBoxRowTypeWrapper:before,\n.selectedBoxRowTypeWrapper:after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: calc(var(--item-size) + 10px);\n    left: 0;\n    right: 0;\n    margin: auto;\n}\n\n.selectedBoxRowTypeWrapper:after {\n    /*top: calc(100% + var(--item-offset) - var(--arrow-size));*/\n    top: calc(100% - 18px);\n    width: 0;\n    height: 0;\n    border-left: var(--arrow-size) solid transparent;\n    border-right: var(--arrow-size) solid transparent;\n\n    border-top: var(--arrow-size) solid var(--arrow-point-color, var(--light-grey));\n}\n\n.selectedBoxRowTypeWrapper:before {\n    /*height: calc(var(--item-offset) - var(--arrow-size) * 2);*/\n    height: calc(100% - var(--item-size) - 20px);\n    width: 1px;\n    background: var(--arrow-color, var(--light-grey));\n}\n\n.selectedBoxRow:last-of-type .selectedBoxRowTypeWrapper:before,\n.selectedBoxRow:last-of-type .selectedBoxRowTypeWrapper:after {\n    display: none;\n}\n\n/*.selectedBoxRow:not(:last-of-type) {*/\n/*    padding-bottom: var(--item-offset);*/\n/*}*/\n\n.selectedBoxRow .investorSelect {\n    min-height: 115px;\n    margin: auto 0;\n    padding: 28px 15px;\n}\n\n.selectedBoxRow .investorSelectTitle {\n    height: auto;\n}\n\n.selectedBoxRow.full {\n    --arrow-color: var(--primary-color-active);\n}\n\n.selectedBoxRow.partial {\n    --arrow-point-color: var(--primary-color-active);\n}\n\n.info {\n    width: 180px;\n}\n\n.info p {\n    font-weight: 300;\n    font-size: 12px;\n    margin: 10px 0;\n    width: 170%;\n}\n\n.separator {\n    margin: 26px 0 40px;\n    border: 0;\n    border-top: 1px solid var(--light-grey);\n}\n\n.countryImg {\n    height: 18px;\n}\n\n.countryImg img {\n    max-height: 100%;\n    width: auto;\n}\n\n.selectedBoxRowType .countryImg {\n    position: absolute;\n    top: 7px;\n    right: 7px;\n}\n\n.selectedBoxRowTypeWrapper.multi {\n    --index: 1;\n\n    position: absolute;\n    height: 100%;\n\n    margin-left: calc(var(--offset-x) * var(--index));\n    margin-top: calc(var(--offset-y) * var(--index));\n}\n\n.selectedBoxRowType:last-child {\n    position: relative;\n}\n\n.selectedBoxRowTypeWrapper.multi:not(:last-child):before,\n.selectedBoxRowTypeWrapper.multi:not(:last-child):after {\n    display: none;\n}\n\n@media screen-md-max {\n    .selectedBoxRow {\n        grid-gap: 10px;\n        --item-size: 80px;\n\n        --offset-y: 15px;\n        --offset-x: 15px;\n    }\n\n    .selectedBoxRowType {\n        /*transform: translateX(40px);*/\n        padding: 18px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .selectedBoxRowType > span,\n    .selectedBoxRowType svg {\n        width: 40px;\n        height: 40px;\n    }\n\n    .info {\n        /*transform: translateX(40px);*/\n    }\n\n    .info p {\n        width: 170%;\n    }\n\n    .info p:first-of-type {\n        display: none;\n    }\n\n    .countryImg {\n        height: 16px;\n    }\n\n    .selectedBoxRowType .countryImg {\n        top: 5px;\n        right: 5px;\n    }\n}\n\n@media screen-lg-min {\n    .selectedBoxRow {\n        --item-size: 100px;\n        justify-content: flex-start;\n    }\n\n    .info p {\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"boxWrapper": `styles_boxWrapper__oJDTY`,
	"selectedBoxRow": `styles_selectedBoxRow__L1L-8`,
	"selectedBoxRowTypeWrapper": `styles_selectedBoxRowTypeWrapper__xN6XX`,
	"selectedBoxRowType": `styles_selectedBoxRowType__LCb7G`,
	"selected": `styles_selected__VqYh0`,
	"selectedIcon": `styles_selectedIcon__l-msI`,
	"investorSelect": `styles_investorSelect__mF5qD`,
	"investorSelectTitle": `styles_investorSelectTitle__SRHpd`,
	"full": `styles_full__HKT9g`,
	"partial": `styles_partial__SYG98`,
	"info": `styles_info__MpFdP`,
	"separator": `styles_separator__BL7Y6`,
	"countryImg": `styles_countryImg__tOXoF`,
	"multi": `styles_multi__62BjY`
};
export default ___CSS_LOADER_EXPORT___;
